import { render, staticRenderFns } from "./DeleteGroupsDialog.vue?vue&type=template&id=747fd04d"
import script from "./DeleteGroupsDialog.vue?vue&type=script&lang=js"
export * from "./DeleteGroupsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports